(function () {
  // Basic EU VAT pattern check (front-end only)
  function isValidEuVat(vatRaw) {
    if (!vatRaw) return false;

    let vat = vatRaw.toUpperCase().replace(/\s+/g, '');
    // If user omitted country code, you could default here, e.g.:
    // if (!/^[A-Z]{2}/.test(vat)) vat = 'BE' + vat;

    // Country-specific length & charset approximations
    const patterns = {
      AT: /^[0-9]{8}$/,             // Austria
      BE: /^[0-9]{10}$/,            // Belgium (incl leading 0)
      BG: /^[0-9]{9,10}$/,          // Bulgaria
      HR: /^[0-9]{11}$/,            // Croatia
      CY: /^[0-9]{8}[A-Z]$/,        // Cyprus
      CZ: /^[0-9]{8,10}$/,          // Czechia
      DK: /^[0-9]{8}$/,             // Denmark
      EE: /^[0-9]{9}$/,             // Estonia
      FI: /^[0-9]{8}$/,             // Finland
      FR: /^[0-9A-Z]{2}[0-9]{9}$/,  // France
      DE: /^[0-9]{9}$/,             // Germany
      EL: /^[0-9]{9}$/,             // Greece (EL)
      GR: /^[0-9]{9}$/,             // (sometimes GR used)
      HU: /^[0-9]{8}$/,             // Hungary
      IE: /^[0-9A-Z]{8,9}$/,        // Ireland
      IT: /^[0-9]{11}$/,            // Italy
      LV: /^[0-9]{11}$/,            // Latvia
      LT: /^[0-9]{9}|[0-9]{12}$/,   // Lithuania
      LU: /^[0-9]{8}$/,             // Luxembourg
      MT: /^[0-9]{8}$/,             // Malta
      NL: /^[0-9A-Z+*]{10}[0-9]{2}$/, // Netherlands (simplified)
      PL: /^[0-9]{10}$/,            // Poland
      PT: /^[0-9]{9}$/,             // Portugal
      RO: /^[0-9]{2,10}$/,          // Romania
      SK: /^[0-9]{10}$/,            // Slovakia
      SI: /^[0-9]{8}$/,             // Slovenia
      ES: /^[0-9A-Z][0-9]{7}[0-9A-Z]$/, // Spain
      SE: /^[0-9]{12}$/             // Sweden
    };

    const country = vat.slice(0, 2);
    const rest = vat.slice(2);

    if (!patterns[country]) return false;
    return patterns[country].test(rest);
  }

  function attachVatValidation() {
    // Adjust this selector to match the Shopify Forms host on your page
    const formHost = document.querySelector('shopify-forms-embed');
    if (!formHost || !formHost.shadowRoot) return false;

    const root = formHost.shadowRoot;

    const vatInput = root.querySelector('#company_tax_id');
    const form = root.querySelector('form');
    if (!vatInput || !form) return false;

    let errorEl = document.createElement('div');
    errorEl.style.color = 'red';
    errorEl.style.fontSize = '12px';
    errorEl.style.marginTop = '4px';
    errorEl.textContent = 'Please enter a valid EU VAT number (e.g. DE123456789).';
    errorEl.hidden = true;
    vatInput.insertAdjacentElement('afterend', errorEl);

    function showError(show) {
      errorEl.hidden = !show;
      vatInput.setAttribute('aria-invalid', show ? 'true' : 'false');
    }

    form.addEventListener('submit', function (e) {
      const value = vatInput.value;
      // If you want to allow empty VAT for Belgian domestic customers,
      // you can change this logic to `if (value && !isValidEuVat(value))`
      if (!isValidEuVat(value)) {
        e.preventDefault();
        e.stopPropagation();
        showError(true);
        vatInput.focus();
      } else {
        showError(false);
      }
    });

    vatInput.addEventListener('blur', function () {
      const value = vatInput.value;
      if (!value) {
        showError(false);
      } else {
        showError(!isValidEuVat(value));
      }
    });

    return true;
  }

  function initWhenReady() {
    if (attachVatValidation()) return;

    const observer = new MutationObserver(() => {
      if (attachVatValidation()) {
        observer.disconnect();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();